import * as React from "react";
import { memo } from "react";

import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";

import MintPage from "./index";
const MintPageApollo = loadable(
  () => import("../../features/MintPage/MintPageApollo")
);
const MintPageByCollectionId = ({ isApollo }: { isApollo?: boolean }) => {
  const { collectionId } = useParams();
  const apolloMintPageUpdate = useFeatureFlags(
    FEATURE_FLAGS.APOLLO_MINT_PAGE_UPDATE
  );

  return apolloMintPageUpdate || isApollo ? (
    <MintPageApollo collectionId={collectionId} />
  ) : (
    <MintPage collectionId={collectionId} />
  );
};

export default memo(MintPageByCollectionId);
